<template>
    <div class="news-bread">
            <template v-for="(item, index) in breads">
                <a :class="'bread-item' + getClassName()" href="javascript:void(0);" @click="gotoBread(item)" v-if="index < breads.length-1">
                    {{item.text}}
                </a>
                <span :class="'bread-split' + getClassName()" v-if="index < breads.length-1">/</span>
                <a v-else :class="'bread-item disabled' + getClassName()" >{{item.text}}</a>
            </template>
            
    </div>
</template>

<script>
export default {
    props:{
         breads:{
            type: Array,
            default: [{
                name: '',
                text: '',
                path: ''
            }]
        },
        // 默认样式类型 1：黑色，2：白色  默认为1
        defaultType:{
            type: String,
            default: '1'
        }
    },
    methods:{
        gotoBread(item){
            let path = item.path;
            if(path.indexOf('?') >= 0){
                const [hash, query] = path.split('?');
                if(query){
                    item.query = {};
                    const strs = query.split('&');
                    for (let i = 0; i < strs.length; i++) {
                        const [key, value] = strs[i].split('=')
                        item.query[key] = value
                    }
                }
            }
            this.$router.push(item);
        },
        getClassName(){
            if(this.defaultType === '1'){
                return ' type1';
            }
            if(this.defaultType === '2'){
                return ' type2';
            }
            return ' type1';
        }
    }
}
</script>


<style lang="less" scoped>
.news-bread{
    .bread-item,.bread-split{
        font-family: SourceHanSansCN-Regular;
        font-size: 14px;
        letter-spacing: 0;
        text-align: justify;
        text-decoration: none;
        line-height: 42px;
    }
    .type1{
        color: rgba(0,0,0,0.50);
    }
    .type2{
        color: #cacaca;
    }

    .disabled.type1,.type1:hover{
        color: black;
    }
    .disabled.type2,.type2:hover{
        color: white;
    }

    .bread-split{
        margin-left: 4px;
        margin-right: 4px;
    }



}
</style>
